import React, { useEffect, useRef, useState } from 'react';
import { AuthButtonWrapper } from './Auth.style';
import { Button } from 'components';
import {
  WebAppleClientId,
  IOSAppleClientId,
  AppleRedirectURI,
} from 'environment';
import { useDispatch } from 'react-redux';
import { handleAppleSignup } from 'redux/features/LoginSlice';
import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';

const AppleLogin = ({ handleAppleClick }) => {
  const hiddenBtnRef = useRef(null);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Web Apple Sign In
    if (!Capacitor.isNativePlatform() && window.AppleID) {
      window.AppleID.auth.init({
        clientId: WebAppleClientId,
        scope: 'name email',
        redirectURI: AppleRedirectURI,
        usePopup: true,
      });
    }
  }, []);

  const handleAppleCredentialResponse = async (response) => {
    if (response?.authorization?.code) {
      setIsLoading(true);
      const payload = {
        code: response.authorization.code,
        platform: Capacitor.getPlatform(),
        userData: {
          firstName: response.user?.name?.firstName || '',
          lastName: response.user?.name?.lastName || '',
        },
      };
      handleAppleClick();
      dispatch(handleAppleSignup(payload))
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
    }
  };

  const triggerAppleLogin = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await SocialLogin.initialize(
          Capacitor.getPlatform() === 'android'
            ? {
                apple: {
                  clientId: WebAppleClientId,
                  redirectUrl: AppleRedirectURI,
                },
              }
            : {
                apple: {
                  clientId: IOSAppleClientId,
                },
              }
        );

        const { result } = await SocialLogin.login({
          provider: 'apple',
          options: {
            scopes: ['name', 'email'],
          },
        });
        const payload = {
          id_token: result?.accessToken?.token,
          platform: Capacitor.getPlatform(),
          userData: {
            firstName: result?.profile?.givenName || '',
            lastName: result?.profile?.familyName || '',
          },
        };
        handleAppleClick();
        setIsLoading(true);
        dispatch(handleAppleSignup(payload))
          .then(() => setIsLoading(false))
          .catch((err) => {
            console.error('Apple login failed:', err);
            setIsLoading(false);
          });
      } catch (err) {
        console.error('Native Apple login failed:', err);
        setIsLoading(false);
      }
    } else {
      const realButton = hiddenBtnRef.current?.querySelector(
        'button[type="appleid-signin"]'
      );
      if (realButton) {
        realButton.click();
      } else {
        // fallback for Apple web popup
        window.AppleID.auth
          .signIn()
          .then(handleAppleCredentialResponse)
          .catch((err) => {
            console.error('Web Apple login failed:', err);
          });
      }
    }
  };

  return (
    <AuthButtonWrapper>
      <div
        ref={hiddenBtnRef}
        style={{ visibility: 'hidden', position: 'absolute' }}
      />
      <Button
        startIcon={<div className="apple-icon"></div>}
        label={isLoading ? 'Loading...' : 'Apple'}
        onClick={triggerAppleLogin}
        variant="outlined"
        className="custom-google-btn custom-apple-btn"
        disableElevation
        disabled={isLoading}
      />
    </AuthButtonWrapper>
  );
};

export default AppleLogin;
